//
// # Default Canvas
//
// This is the default canvas implementation, which is used if no canvas is provided.
//

// export { TwoCanvas as DefaultCanvas } from "./draw/two/canvas";
export { HtmlCanvas as DefaultCanvas } from "./draw/htmlcanvas/root";
